import { ActionIcon } from "@mantine/core"
import { IconList, IconTable } from "@tabler/icons-react"

interface Props {
  value: "list" | "table"
  onChange: (value: "list" | "table") => void
}
export function ListTableActionIconGroup({ value, onChange }: Props) {
  return (
    <ActionIcon.Group>
      <ActionIcon disabled={value === "list"} onClick={() => onChange("list")}>
        <IconList />
      </ActionIcon>
      <ActionIcon
        disabled={value === "table"}
        onClick={() => onChange("table")}
      >
        <IconTable />
      </ActionIcon>
    </ActionIcon.Group>
  )
}
